<ng-template #alertTemplate>
  <mbs-button
    *ngIf="isRedirectEnabled"
    [isCtrl]="true"
    (click)="redirect()"
    [size]="MbsSize.md"
    type="primary">
    {{ totalUnsupportedComputers }}
    {{ 'shared:error.unsupportedVersion:computer' + (isMultipleUnsupportedComputers ? 's' : '') | i18next }}
  </mbs-button>
  <span *ngIf="!isRedirectEnabled">
    {{ totalUnsupportedComputers }}
    {{ 'shared:error.unsupportedVersion:computer' + (isMultipleUnsupportedComputers ? 's' : '') | i18next }}
  </span>
  {{ 'shared:error.unsupportedVersion:' + (isMultipleUnsupportedComputers ? 'areRunning' : 'isRunning') | i18next }}
  <mbs-button
    *ngIf="isRedirectEnabled"
    [isCtrl]="true"
    (click)="redirect()"
    [size]="MbsSize.md"
    type="primary">
    {{ 'shared:error.unsupportedVersion.update' | i18next }}
  </mbs-button>
  <span *ngIf="!isRedirectEnabled">
    {{ 'shared:error.unsupportedVersion.update' | i18next }}
  </span>
  {{ 'shared:error.unsupportedVersion.asap' | i18next }}
</ng-template>
